import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-news-info-section',
  templateUrl: './news-info-section.component.html',
  styleUrls: ['./news-info-section.component.scss']
})
export class NewsInfoSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
